import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import './Legal.css';

export default function TermsOfService() {
  const navigate = useNavigate();
  useDocumentTitle('Terms of Service');

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} />
          Back
        </button>

        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: March 23, 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using TekStak ("the Service"), you agree to be bound by these
            Terms of Service. If you do not agree to these terms, do not use the Service.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            TekStak is a technology procurement management platform designed for government
            IT teams. The Service provides AI-powered classification, spend analysis,
            Zero Trust security assessments, and procurement data management capabilities.
          </p>
        </section>

        <section>
          <h2>3. User Accounts</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials
            and for all activities that occur under your account. You must notify us immediately
            of any unauthorized use of your account.
          </p>
        </section>

        <section>
          <h2>4. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to any part of the Service</li>
            <li>Upload malicious content or interfere with the Service's operation</li>
            <li>Share your account credentials with unauthorized individuals</li>
            <li>Scrape, crawl, or use automated means to access the Service without permission</li>
          </ul>
        </section>

        <section>
          <h2>5. Data and Privacy</h2>
          <p>
            Your use of the Service is also governed by our Privacy Policy. Procurement data
            uploaded to the Service remains your property. We process it solely to provide
            classification and analysis services.
          </p>
        </section>

        <section>
          <h2>6. Service Availability</h2>
          <p>
            We strive to maintain high availability but do not guarantee uninterrupted access.
            The Service may be temporarily unavailable for maintenance or updates.
          </p>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>
            The Service is provided "as is" without warranties of any kind. TekStak shall not
            be liable for any indirect, incidental, or consequential damages arising from
            your use of the Service.
          </p>
        </section>

        <section>
          <h2>8. Changes to Terms</h2>
          <p>
            We may update these Terms from time to time. Continued use of the Service after
            changes constitutes acceptance of the updated Terms.
          </p>
        </section>

        <section>
          <h2>9. Contact</h2>
          <p>
            For questions about these Terms, contact us at{' '}
            <a href="mailto:support@tekstak.app">support@tekstak.app</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
